<template>
  <loader :height="90" text="Идет разработка"/>
</template>

<script>
  import Loader from '@/components/Loader'

  export default {
    name: 'Stations',
    components: {Loader},
    data() {
      return {
        loaded: false,
      }
    },
  }
</script>
<style scoped>

</style>